import Input, { InputProps } from './Input';
import { classNames } from '../common/utils/utils';
import FormReadOnlyElement from './FormReadOnlyElement';

interface FormInputProps extends InputProps {
  errorMessage?: string;
  displayHelper?: boolean;
  id?: string;
}

const FormInput = ({
  errorMessage,
  readOnly,
  value,
  label,
  className,
  helper,
  displayHelper,
  id,
  ...props
}: FormInputProps) => {
  return readOnly ? (
    <FormReadOnlyElement
      id={id}
      label={label || ''}
      value={value instanceof Array ? value.join(', ') : value}
    />
  ) : (
    <Input
      value={value}
      label={label}
      className={classNames(
        errorMessage
          ? 'border border-red-500 text-red-900 focus:ring-red-500 focus:border-red-500'
          : '',
        className || '',
      )}
      aria-invalid={errorMessage ? 'true' : 'false'}
      id={id}
      {...props}
      helper={errorMessage && displayHelper !== false ? <p className="text-red-500">{errorMessage}</p> : <p className='text-gray-500 text-sm'>{helper}</p>}
    />
  );
};

export default FormInput;
